<div class="treenode">
  <div>
    @if (HasCheckbox) {
      <span>
        @if (Checked) {
          <input type="checkbox" style="accent-color: green;" (click)="HandleSelectedClick($event)" checked [disabled]="NodeDisabled">
        }
        @if (!Checked) {
          <input type="checkbox" style="accent-color: green;" (click)="HandleSelectedClick($event)" [disabled]="NodeDisabled">
        }
      </span>
    }
    @if (!HasCheckbox) {
      <span style="padding-left:18px;"></span>
    }
    <span class="node-text" [ngClass]="{ 'is-active' : Selected}" [ngStyle]="{'color': (HasChildItemsSelected || Checked) ? '#2E8637' : 'black', 'font-weight': (HasChildItemsSelected || Checked) ? 'bold' : 'normal'}"  (click)="HandleClick($event)" (dblclick)="HandleDoubleClick($event)">
      @if (Image != null) {
        <img class="node-image" [src]="Image" />
      }
      {{Text}}
    </span>
    @if (SelectItems != null && SelectItems.length > 1) {
      <span class="has-text-grey-light">
        <select [(ngModel)]="SelectItemValue" (change)="HandleSelectedChange($event)" [disabled]="NodeDisabled">
          <option value="0" disabled selected>No Access</option>
          @for (s of SelectItems; track s) {
            <option [value]="s.Level" [selected]="">{{s.Permission}}</option>
          }
        </select>
      </span>
    }
    @if (CanExpand && !Expanded) {
      <span class="fa fa-chevron-right" (click)="Toggle()"></span>
    }
    @if (CanExpand && Expanded) {
      <span class="fa fa-chevron-down" (click)="Toggle()"></span>
    }
    @if (CanDelete) {
      <span (click)="HandleDelete($event)" class="has-text-grey-light"><i class="fa fa-trash"></i> </span>
    }
    <span class="has-text-grey-light">{{TrailingInfo}}</span>
  </div>
  @if (Expanded) {
    <div class="node-content">
      <ng-content></ng-content>
    </div>
  }
</div>